import React from 'react'
import { Typography, Box } from '@mui/material'
import DOMPurify from 'dompurify'
interface DescriptionProps {
  hotspots?: any
}
const Description = ({ hotspots }: DescriptionProps) => {
  return (
    <>
    {hotspots.map((hotspot: any) => (
      <Box
        key={hotspot.id ?? hotspot.title}
        component={'div'}
        sx={{ mb: 3 }}
      >
        <Typography
          component='h4'
          variant='h6'
          sx={{ mb: 1, fontWeight: 'bold' }}
        >
          {hotspot.title}
        </Typography>
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(hotspot.description, { ADD_ATTR: ['target'] }),
          }}
        />
      </Box>
    ))}
    </>
  )
}

export default Description
